// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "route.ui-page{width:100%;height:100%;padding:0;margin:0}", "",{"version":3,"sources":["webpack://./pos/app/scripts/components/route/route.scss"],"names":[],"mappings":"AAAA,cACE,UAAA,CACA,WAAA,CACA,SAAA,CACA,QAAA","sourcesContent":["route.ui-page {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
